import React, { FC } from 'react';
import i18n from 'i18n';
import styled from 'styled-components';

import Modal from '../../Modal/index';
import { RowsContainer } from '../Common';
import { ModalProps } from '../types';

const PrivateContentContainer = styled(RowsContainer)`
  text-align: center;
  margin-bottom: 25px;
`;

interface PrivateModalProps extends ModalProps {

}

export const PrivateModal: FC<PrivateModalProps> = ({ app, onCancel, onSuccess }) => (
  <Modal
    id={`PrivateModal`}
    title={i18n('component.PrivateModal.Title')({ type: app.type })}
    onClose={onCancel}
    contentCenter={
      <PrivateContentContainer>
        {i18n('component.PrivateModal.Content')({ type: app.type })}
      </PrivateContentContainer>
    }
    buttons={[
      {
        text: i18n('component.PrivateModal.CancelText')(),
        onClick: onCancel,
        testType: 'cancel-private-button',
        id: 'private-button-cancel'
      },
      {
        text: i18n('component.PrivateModal.InstallText')(),
        onClick: onSuccess,
        highlight: true,
        testType: 'install-private-button',
        id: 'install-private-button-ok'
      }
    ]}
  />
);
